class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('CartDrawer');
    this.content = document.getElementById('CartDrawer-Content');
    this.liveRegion = document.getElementById('CartDrawer-LiveRegion');
    this.activeTrigger = null;

    if (!this.drawer || !this.content) return;

    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('click', (event) => {
      const openBtn = event.target.closest('[data-cart-drawer-open]');
      const closeBtn = event.target.closest('[data-cart-drawer-close]');
      const qtyBtn = event.target.closest('[data-cart-quantity-change]');
      const removeBtn = event.target.closest('[data-cart-remove]');

      if (openBtn) {
        event.preventDefault();
        this.activeTrigger = openBtn;
        this.open();
        return;
      }

      if (closeBtn) {
        event.preventDefault();
        this.close();
        return;
      }

      if (qtyBtn) {
        event.preventDefault();
        const line = Number(qtyBtn.dataset.line);
        const quantity = Math.max(0, Number(qtyBtn.dataset.quantity));
        this.updateQuantity(line, quantity);
        return;
      }

      if (removeBtn) {
        event.preventDefault();
        const line = Number(removeBtn.dataset.line);
        this.updateQuantity(line, 0);
      }
    });

    document.addEventListener('change', (event) => {
      const input = event.target.closest('[data-cart-quantity-input]');
      if (!input) return;

      const line = Number(input.dataset.line);
      const quantity = Math.max(0, Number(input.value));
      this.updateQuantity(line, quantity);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.drawer.hasAttribute('hidden')) {
        this.close();
      }
    });
  }

  open() {
    this.drawer.removeAttribute('hidden');
    document.body.classList.add('overflow-hidden');

    const panel = this.drawer.querySelector('.cart-drawer__panel');
    if (panel) panel.focus();
  }

  close() {
    this.drawer.setAttribute('hidden', '');
    document.body.classList.remove('overflow-hidden');
  }

  async addItem(variantId, quantity = 1) {
    const body = {
      items: [
        {
          id: Number(variantId),
          quantity: Number(quantity)
        }
      ],
      sections: this.getSectionsToRender(),
      sections_url: window.location.pathname
    };

    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || 'Failed to add item to cart.');
    }

    await this.renderSections(data.sections);
    this.announce('Item added to cart.');
    this.open();

    return data;
  }

  async updateQuantity(line, quantity) {
    const body = {
      line: Number(line),
      quantity: Number(quantity),
      sections: this.getSectionsToRender(),
      sections_url: window.location.pathname
    };

    const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });

    const data = await response.json();

    if (!response.ok) {
      console.error(data);
      // this.announce('Unable to update cart.');
      return;
    }

    await this.renderSections(data.sections);
    // this.announce('Cart updated.');
    this.open();

    return data;
  }

  getSectionsToRender() {
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  async renderSections(sections) {
    if (!sections) {
      console.warn('No sections returned from cart request.');
      return;
    }

    const drawerHTML = sections['cart-drawer'];

    if (!drawerHTML) {
      console.warn('cart-drawer section was not returned.', sections);
      return;
    }

    const parsedDrawer = new DOMParser().parseFromString(drawerHTML, 'text/html');
    const newContent = parsedDrawer.querySelector('#CartDrawer-Content');
    const currentContent = document.querySelector('#CartDrawer-Content');

    if (!newContent || !currentContent) {
      console.warn('CartDrawer-Content not found in returned section HTML.');
      return;
    }

    currentContent.innerHTML = newContent.innerHTML;
    this.content = document.getElementById('CartDrawer-Content');

    const bubbleHTML = sections['cart-icon-bubble'];

    if (bubbleHTML) {
      const parsedBubble = new DOMParser().parseFromString(bubbleHTML, 'text/html');
      const newBubble = parsedBubble.querySelector('#cart-icon-bubble');
      const currentBubble = document.querySelector('#cart-icon-bubble');

      if (newBubble && currentBubble) {
        currentBubble.innerHTML = newBubble.innerHTML;
      }
    }
  }

  announce(message) {
    if (!this.liveRegion) return;

    this.liveRegion.textContent = '';

    window.setTimeout(() => {
      this.liveRegion.textContent = message;
    }, 50);
  }
}

if (!window.cartDrawer) {
  window.cartDrawer = new CartDrawer();
}

if (!window.__cartDrawerSubmitBound) {
  window.__cartDrawerSubmitBound = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.js-add-to-cart');
    if (!button || !window.cartDrawer) return;

    const form = button.closest('form[action*="/cart/add"]');
    if (!form) return;

    event.preventDefault();

    if (form.dataset.submitting === 'true') return;
    form.dataset.submitting = 'true';

    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');

    try {
      const formData = new FormData(form);
      const variantId = formData.get('id');
      const quantity = Number(formData.get('quantity') || 1);

      await window.cartDrawer.addItem(variantId, quantity);
    } catch (error) {
      console.error(error);
      const productAlert = document.querySelector('[data-product-alert]');
      productAlert.hidden = false;
      productAlert.classList.add('alert-error');
    } finally {
      form.dataset.submitting = 'false';
      button.disabled = false;
      button.removeAttribute('aria-disabled');
    }
  });
}